var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable } from 'mobx';
import AlertAPI from '@/alert/api/AlertAPI';
import { SystemAlert } from '@/alert/entities/SystemAlert';
import useStore from '@/common/hooks/useStore';
import Notifier from '@/common/services/Notifier';
import Storage, { KEY_READ_ALERTS } from '@/common/services/Storage';
export default class AlertStore {
    alerts = [];
    closingAlerts = [];
    alertAPI;
    constructor() {
        this.alertAPI = new AlertAPI();
    }
    getAlerts = async () => {
        try {
            const response = await this.alertAPI.getAlerts();
            const idsInStorage = Storage.getObject(KEY_READ_ALERTS, Storage.STORAGE_LOCAL);
            const existedIds = idsInStorage?.split(',') ?? [];
            this.alerts = response.content
                .filter((alert) => !existedIds.includes(alert.id))
                .map((model) => new SystemAlert(model))
                .slice()
                .sort((a, b) => a.priority - b.priority);
        }
        catch (e) {
            Notifier.error(e);
            throw e;
        }
    };
    closeAlert = async (id) => {
        if (this.closingAlerts.includes(id)) {
            return;
        }
        this.closingAlerts.push(id);
        try {
            await this.alertAPI.readAlert(id);
            await this.getAlerts();
        }
        catch (e) {
            Notifier.error(e);
            throw e;
        }
        finally {
            this.closingAlerts.splice(this.closingAlerts.indexOf(id), 1);
        }
    };
    closeAlertLocally = (id) => {
        // TODO use "Storage.pullout"
        const idsInStorage = Storage.getObject(KEY_READ_ALERTS, Storage.STORAGE_LOCAL);
        if (idsInStorage) {
            const existedIds = idsInStorage.split(',');
            existedIds.push(id);
            Storage.saveObject(KEY_READ_ALERTS, existedIds.join(','), Storage.STORAGE_LOCAL);
        }
        else {
            Storage.saveObject(KEY_READ_ALERTS, id, Storage.STORAGE_LOCAL);
        }
        this.alerts = this.alerts.filter((alert) => alert.id !== id);
    };
}
__decorate([
    observable
], AlertStore.prototype, "alerts", void 0);
__decorate([
    action
], AlertStore.prototype, "getAlerts", void 0);
__decorate([
    action
], AlertStore.prototype, "closeAlert", void 0);
__decorate([
    action
], AlertStore.prototype, "closeAlertLocally", void 0);
export const useAlertStore = () => useStore(AlertStore);
export const alertStore = new AlertStore();
